<template>
  <v-dialog v-model='dialog' fullscreen hide-overlay transition='dialog-bottom-transition'>
    <v-card>
      <div class="stickyTwo">
      <v-toolbar dark class='bgclr'>
        <v-btn icon dark @click='closeDialog'>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text  color='white' @click='save'>Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      </div>
      <v-container>
        <v-form  ref='form' v-model='valid' lazy-validation>
                    <v-row>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-text-field
                          v-model='editedItem.name' :rules="jurisdictionRules" validate-on-blur
                          :maxlength='maxLength'
                          hint='The current Jurisdiction name.'
                          label='Jurisdiction name*' required
                        ></v-text-field>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-text-field
                          v-model='editedItem.knownAs'
                          hint='If the Jurisdiction name has formally changed then include the former name.'
                          :maxlength='maxLength'
                          label='Formerly Known As'
                        ></v-text-field>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-text-field
                          v-model='editedItem.fips'
                          hint='The 5-digit census code for the Jurisdiction.'
                          :maxlength='max'
                          label='FIPS'
                          :rules="fipsRules"
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete validate-on-blur
                          v-model='editedItem.countryId'
                          @change='filterState'
                          :rules='countryRules'
                          :items='countryList'
                          item-text='name'
                          item-value='id'
                          label='Country*'
                          required
                          return-object
                          persistent-hint
                          hint='The country that the Jurisdiction resides in.'
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete
                          v-model='editedItem.stateId'
                          @change='filterCounty'
                          :disabled="!isEditingState"
                          :rules='stateRules'
                          :items="stateList.length >= 1 ? stateList : []"
                          item-text='name'
                          item-value='id'
                          label='State*'
                          persistent-hint
                          hint='The state that the Jurisdiction resides in'
                          required
                        ></v-autocomplete>
                        <span v-if="stateErrorCheck" class="caption fonte-weigth-light red--text">{{stateError}}</span>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete
                          multiple
                          chips
                          v-model='editedItem.countyId'
                          :disabled="!isEditingCounty"
                          :items="counties.length >= 1 ? counties : []"
                          item-text='name'
                          item-value='id'
                          label='County'
                        >
                        <template v-slot:selection="item">
                         <v-chip
                         close
                         color="grey lighten-1"
                         @click="item.select"
                        @click:close="removeCounty(item)"
                        >{{item.item.name}}</v-chip>
                         </template>
                        </v-autocomplete>
                        <span v-if="countyErrorCheck" class="caption fonte-weigth-light red--text">{{countyError}}</span>
                      </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete
                          v-model='editedItem.profileId'
                          :items="adoptionProfileList"
                          item-text='name'
                          item-value="id"
                          label='Adoption Profile'
                          clearable
                          persistent-hint
                          hint='Select from the dropdown how the Jurisdiction handles the adoption process.'
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete @change="amendmentAllowed"
                          v-model='editedItem.amendmentsAllowed'
                          :items="['NA', 'YES', 'NO']"
                          label='Amendments Allowed'
                          persistent-hint
                          hint='Will the Jurisdiction adoption allow amendments YES / NO?'
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete
                          :disabled="!isEditing"
                          @change="amendmentMadeAllowed"
                          hint="Amendments have been made YES / NO."
                          v-model='editedItem.amendmentsMade'
                          :items="['NA', 'YES', 'NO']"
                          item-text='name'
                          item-value='id'
                          label='Amendments Made'
                          persistent-hint
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-text-field validate-on-blur
                          :disabled="!isEditingAmendments"
                          v-model='editedItem.amendments'
                          hint="Please select 'Amendments Made' as 'Yes' to edit this field."
                          label='Amendments'
                          :rules = "!isEditingAmendments ? undefined : amendmentRules"
                          required
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-text-field type="url" :rules='urlRules' validate-on-blur
                          v-model='editedItem.url'
                          hint='The Jurisdiction home website.'
                          label='Code Office URL'
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols='6' sm='3' md='3' lg='4'>
                        <v-file-input
                        accept="image/png, image/jpg"
                        label='Attach Logo File'
                        persistent-hint
                        hint="Attach an image of your logo. Recommended dimensions 250*100px"
                        v-model="chosenFile"
                        :rules='[IsValidImage]'
                        @change="importLogoFile"
                        clearable
                        >
                        </v-file-input>
                      </v-col>
                      <v-col cols='8' sm='4' md='4' lg='5'>
                        <v-autocomplete
                        multiple
                        label='Postal Code'
                        hint="Please add Postal Code."
                        v-model="editedItem.postalCodeId"
                        :items="postalList"
                        item-text="postalCode"
                        item-value="id"
                        chips
                        >
                         <template v-slot:selection="item">
                          <v-chip
                          color="grey lighten-1"
                          close
                          @click="item.select"
                          @click:close="remove(item)"
                          >{{item.item.postalCode}}</v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-icon @click="addPostalCodeBtn">mdi-plus</v-icon>
                      <v-col>
                        <v-select
                          v-model='defaultStatus'
                          :items="defaultStatusItems"
                          label="Status*"
                          :rules="statusValidationRules"
                          id="statusFieldId"
                        ></v-select>
                      </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            v-model='editedItem.adoptionDescription'
                            label="Adoption Description"
                            hint="Add Adoption Description"
                            placeholder="Add Adoption Description"
                            clearable
                            dense
                            rows=3
                            filled
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            v-model='editedItem.usefulLinks'
                            label="Useful Links"
                            hint="Add legend and link in pair, like legend1||link1, legend2||link2. For multiple entry use comma(,) as separated"
                            placeholder="Add Useful Links"
                            persistent-hint
                            clearable
                            dense
                            rows=3
                            filled
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-dialog v-if="addPostalDialog" v-model='addPostalDialog'>
                    <template>
                      <add-postal-code @resetPostalDialog='addPostalDialog = $event' :addPostalDialogProp = 'addPostalDialog'></add-postal-code>
                    </template>
                    </v-dialog>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import AddPostalCode from './ManageAddPostalCode'

export default {
  data: () => ({
    formTitle: CONSTANTS.ADD_JURISDICTION,
    valid: true,
    maxLength: 50,
    max: 5,
    addPostalDialog: false,
    chosenFile: undefined,
    amendmentsMax: 100,
    isEditingState: false,
    totalAdoptions: 0,
    isEditingCounty: false,
    isEditingAmendments: false,
    stateErrorCheck: false,
    countyErrorCheck: false,
    isEditing: false,
    countyError: false,
    stateError: false,
    jurisdictionRules: [
      v => !!v || 'Jurisdiction name is required.'
    ],
    knownAsRules: [v => {
      if (v && !/^[A-Za-z. ]+$/.test(v)) {
        return 'Invalid input. Only characters (A-Z, a-z), period and space allowed!'
      } else {
        return true
      }
    }],
    countryRules: [
      v => !!v || 'Country name is required.'],
    stateRules: [
      v => !!v || 'State name is required.'],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    fipsRules: [v => {
      if (v && !/^[0-9]+$/.test(v)) {
        return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
      } else {
        return true
      }
    }, v => {
      if (v && v.length !== 5) {
        return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
      } else {
        return true
      }
    }],
    urlRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    amendmentRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else if (v === '') {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    logoRules: [v => {
      if (v !== {}) {
        const val = v.name
        if (val && val !== undefined && val !== null &&
        val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'JPEG') {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      } else {
        return true
      }
    }],
    amendments: [value => !!value || 'Amendments is required.'],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    editedItem: {
      name: '',
      knownAs: '',
      countryId: '',
      fips: '',
      stateId: '',
      countyId: '',
      profileId: '',
      profileName: 'NA',
      amendmentsAllowed: 'NA',
      amendmentsMade: 'NA',
      amendments: '',
      jurisdictionInput: '',
      url: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      postalCodeId: [],
      status: '',
      adoptionDescription: '',
      usefulLinks: ''
    },
    defaultItem: {
      profileName: 'NA',
      amendmentsAllowed: 'NA',
      amendmentsMade: 'NA',
      amendments: '',
      countryId: '',
      stateId: '',
      name: '',
      fips: '',
      countyId: '',
      profileId: '',
      knownAs: '',
      jurisdictionInput: '',
      url: '',
      postalCodeId: [],
      status: '',
      adoptionDescription: '',
      usefulLinks: ''
    }
  }),
  props: {
    userId: {
      type: Number,
      required: true
    },
    addDialogProp: {
      type: Boolean,
      required: true
    }
  },
  components: {
    'add-postal-code': AddPostalCode
  },
  computed: {
    dialog () {
      return this.addDialogProp
    },
    countryList () {
      let cList = this.$store.getters['CountryModule/fetchCountryList']
      if (Object.keys(cList).length !== 0) {
        let newCList = this.$globalStates.makeUSAAsFirstItem(cList)
        return newCList
      } else {
        return cList
      }
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    counties () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    adoptionProfileList () {
      let adoptionList = this.$store.getters['AdoptionProfileModule/fetchAdoptionProfileList']
      if (adoptionList.length > 0) {
        let newAdoptionList = this.$globalStates.makeNAAsFirstItem(adoptionList)
        return newAdoptionList
      } else {
        return adoptionList
      }
    },
    postalList () {
      return this.$store.getters['PostalCodeModule/fetchPostalCodeList']
    }
  },
  methods: {
    filterState () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.countryId) {
        this.editedItem.stateId = ''
        this.isEditingState = true
      } else {
        this.isEditingState = false
      }
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = this.editedItem.countyId ? this.editedItem.countyId : ''
          this.isEditingCounty = false
          this.stateErrorCheck = false
          // this.filterCounty()
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.isEditingState = false
          this.editedItem.stateId = null
          this.editedItem.countyId = null
          this.countyErrorCheck = false
          this.stateErrorCheck = true
          this.stateError = CONSTANTS.NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY
          // add loader on button if required
        })
    },
    amendmentAllowed () {
      if (this.editedItem.amendmentsAllowed === 'YES') {
        this.isEditing = true
      } else {
        this.isEditingAmendments = false
        this.isEditing = false
        this.editedItem.amendmentsMade = 'NA'
        this.editedItem.amendments = 'NA'
      }
      return this.isEditing
    },
    amendmentMadeAllowed () {
      if (this.editedItem.amendmentsMade === 'YES') {
        this.isEditingAmendments = true
      } else {
        this.isEditingAmendments = false
        this.editedItem.amendments = 'NA'
      }
      return this.isEditingAmendments
    },
    // Import Logo File selected by User
    importLogoFile (e) {
      if (!this.chosenFile) { this.chosenFile = undefined }
      this.chosenFile = e
      return this.chosenFile
    },
    // Fetch state based on country ID selected from dropdown
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.stateId) {
        this.editedItem.countyId = ''
        this.isEditingCounty = true
      } else {
        this.isEditingCounty = false
      }
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      const stateId = this.editedItem.stateId
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = this.editedItem.countyId ? this.editedItem.countyId : ''
          this.countyErrorCheck = false
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.editedItem.countyId = ''
          this.countyErrorCheck = true
          this.countyError = CONSTANTS.NO_COUNTY_IS_AVAILABLE_FOR_THE_SELECTED_STATE
          // add loader on button if required
        })
    },
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      this.chosenFile = undefined
      this.isEditing = false
      this.isEditingAmendments = false
      this.isEditingState = false
      this.isEditingCounty = false
      this.countyErrorCheck = false
      this.stateErrorCheck = false
      this.defaultStatus = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.$emit('resetDialog', this.addDialog)
    },
    addPostalCodeBtn () {
      this.addPostalDialog = true
    },
    remove (item) {
      const index = this.editedItem.postalCodeId.indexOf(item.item.id)
      if (index >= 0) this.editedItem.postalCodeId.splice(index, 1)
    },
    removeCounty (item) {
      const index = this.editedItem.countyId.indexOf(item.item.id)
      if (index >= 0) this.editedItem.countyId.splice(index, 1)
    },
    save () {
      if (this.$refs.form.validate()) {
        let statusField = 1
        if (this.defaultStatus === 'Inactive') {
          statusField = this.statusValues.Inactive
        } else if (this.defaultStatus === 'Published') {
          statusField = this.statusValues.Published
        }
        let formData = new FormData()
        formData.append('logo', (this.chosenFile !== undefined) ? this.chosenFile : '')
        formData.append('name', this.editedItem.name)
        formData.append('countryId', this.editedItem.countryId.id ? this.editedItem.countryId.id : '')
        formData.append('stateId', this.editedItem.stateId)
        formData.append('countyId', this.editedItem.countyId)
        formData.append('fips', (this.editedItem.fips !== undefined) ? this.editedItem.fips : '')
        formData.append('formerlyKnownAs', (this.editedItem.knownAs !== undefined) ? this.editedItem.knownAs : '')
        formData.append('adoptionProfile', this.editedItem.profileId)
        formData.append('amendmentsAllowed', this.editedItem.amendmentsAllowed)
        formData.append('amendmentsMade', this.editedItem.amendmentsMade)
        formData.append('url', (this.editedItem.url !== undefined) ? this.editedItem.url : '')
        formData.append('amendments', this.editedItem.amendments)
        formData.append('userId', this.userId)
        formData.append('status', statusField)
        formData.append('postalCodeId', this.editedItem.postalCodeId)
        formData.append('adoptionDescription', (this.editedItem.adoptionDescription !== undefined) ? this.editedItem.adoptionDescription : '')
        formData.append('usefulLinks', (this.editedItem.usefulLinks !== undefined || this.editedItem.usefulLinks !== null) ? this.editedItem.usefulLinks : '')
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/addJurisdictionItem', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.text = responseData.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'green'
            this.closeDialog()
          })
          .catch(response => {
            this.$globalStates.notification.text = response.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'red'
          })
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/getJurisdictionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.$emit('resetTotalAdoptions', this.totalAdoptions)
            this.loading = false
          })
          .catch(response => {
          })
      }
    },
    IsValidImage (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPEG'
        ) {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>
